import api from "../utils/apiClient";

export const getStockDataUsingConfigId = async (configId) => {
    try {
        const response = await api.get(`/api/stock?appConfig=${configId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching stock data:', error);
        throw error;
    }
}
